/** Resolves when Amplify.configure has finished (homepage can use defaults until then). */
let resolveReady: () => void;
export const amplifyConfigured = new Promise<void>((resolve) => {
  resolveReady = resolve;
});

export function markAmplifyConfigured(): void {
  resolveReady();
}
